export default __webpack_public_path__ + "static/media/pricing-enterprise-gray-icon.bcef0ca0.webp";